import React, { Component } from 'react';
import {connect} from 'react-redux';
import { change, Field, reduxForm } from 'redux-form';

import { addRoomByCommunity, updRoom } from '../../actions/roomAction';

import { Button, Checkbox, Grid, Paper } from '@material-ui/core';
import { renderLegacyTextField } from '../../utils/engageComponents';
import { CheckBox, CheckBoxOutlineBlank } from '@material-ui/icons';
import { sweetAlert } from '../../components/Alert/sweetAlert';

const validate = (values, props) => {
    const errors = {};
    if (!values.name) {
        errors.name = 'Please enter a Name';
    } else if (values.name.length > props.characterLimit) {
        errors.name = `The Room must have less than 30 characters`
    }

    return errors;
};


class AddEditRoom extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: true,
            commonRoom:undefined,
            _id: props?.data?._id? props.data._id: null,
            SweetAlertStyles: {modalStyles:{backgroundColor: '#ffffff'}, messageClass:'LAlertMessageStyles'},

        
        };

        if (props.data) {
            this.props.dispatch(change('RoomForm', '_id', props.data && props.data._id));
            this.props.dispatch(change('RoomForm', 'name', props.data && props.data.name));
        } else {
            this.props.dispatch(change('RoomForm', '_id', ''));
            this.props.dispatch(change('RoomForm', 'name', ''));
        }
    }

    componentDidMount(){

        this.setState({commonRoom: (this.props.data && this.props.data.isCommonRoom)? true: false});
    }

    onSubmitHandler=(formData)=>{

        if (formData.name.length > 30) {
            const message = `The room must have less than ${this.props.characterLimit} characters`
            sweetAlert('error', message, 'alert_AddEditRoom_CharacterLimit_Error', this.state.SweetAlertStyles? this.state.SweetAlertStyles : {});
            return;
        }
    
        formData.isCommonRoom =  this.state.commonRoom;
    
        if(!this.state._id){
            this.props.addRoomByCommunity(formData, localStorage.getItem('communityId'), this.state.SweetAlertStyles? this.state.SweetAlertStyles : {}); //this.state._id);
        }else {
            this.props.updRoom(this.state._id, formData, this.state.SweetAlertStyles? this.state.SweetAlertStyles : {}); //this.state._id);
        }

        this.props.close();
    }

    render() {
        const { handleSubmit } = this.props;

        return (
            <>
                <Paper elevation={3} square='false' color='secondary'>
                    <Grid id='add_room_modal' className="LpaperModal">
                        <form style={{height:'100%'}}>
                            <Grid item container xs={12} style={{height:'80%'}} alignItems='baseline'>
                                <Grid item xs={12} className='lmodalTitle'>{this.props.data? 'Update Room': 'New Room'}</Grid>
                                <Grid item xs={12} sm={12} md={8} lg={8} className='LformSection sectionMargin'>
                                    <Field
                                        id='rooms_add_room_name'
                                        name="name"
                                        label="Name"
                                        maxLength={20}
                                        component={renderLegacyTextField}
                                        inputLabelClass='ldefaultTextStyles'
                                        inputClass='ldefaultTextStyles'
                                    />
                                </Grid>
                                <Grid item container xs={12} className='sectionMargin'>
                                    <Grid item xs={12} sm={12} md={8} lg={8} className="LcharacterCount">When you add a new Room, be sure to assign Items to the new Room for proper display on residents' Engage systems. See Items tab above.</Grid>
                                </Grid>

                                <Grid item container xs={12} className='sectionMargin' alignItems='center' style={{height:'30%'}}>
                                    <Grid item container xs={12} sm={1} md={1} lg={1} justifyContent="center" alignContent="center">
                                        <Grid item className='CheckboxBlue RepairsCell'>
                                            <Checkbox
                                                id={`commonRoom_checkbox`}
                                                checked={this.state.commonRoom? false : true}
                                                onClick={(e) => e.stopPropagation()}
                                                onChange={() => {this.setState((prevState) => ({commonRoom: !prevState.commonRoom}))}}
                                                icon={<CheckBoxOutlineBlank fontSize="large" />}
                                                checkedIcon={
                                                    <CheckBox fontSize="large" />
                                                }
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid item container xs={12} sm={10} md={10} lg={10} justifyContent='flex-start' alignContent="center" style={{color:'black', fontFamily:'Gotham-Bold', fontSize:'18px'}} className='sectionMargin'>
                                        <Grid item>
                                            Display this room as an option for residents on their TV. Uncheck if a common area (i.e. Lobby, Dining Room, etc.)
                                        </Grid>
                                    </Grid>
                                </Grid>

                               
                            </Grid>

                              {/* Buttons section */}
                            <Grid item container justifyContent='space-evenly' xs={12} alignItems='center' style={{height:'20%'}}>
                                <Button id='cancel_btn' item container className="lcancelBtn" onClick={()=>this.props.close()}>
                                    Cancel
                                </Button>
                 
                                <Button id='save_btn' item container className="Lsetup_btn" onClick={handleSubmit(this.onSubmitHandler.bind(this))}>
                                    Save
                                </Button>

                            </Grid>
                        </form>


                    
                    </Grid>
               
                </Paper>
            </>
        )
    }
}

function mapStateToProps(state,dispatch) {

    return{
    }
};

export default connect(mapStateToProps, { addRoomByCommunity, updRoom})(reduxForm({
    form: 'RoomForm',
    validate,
    enableReinitialize: true,
})(AddEditRoom));


